import Button from "@mui/material/Button";
// import styled from "@mui/material/styles/styled";
import { styled } from "@mui/material/styles";
const CustomTabSmallButton = styled(Button)(({ theme }) => ({
  minWidth: "100px",
  borderRadius: 0,
  textTransform: "none",
  fontWeight: "bold",
  opacity: 1,
  color: "gray",
  fontFamily: "Proxima Nova",
  background: "#f8f9f9",
  "&.Mui-selected": {
    backgroundColor: "rgba(67, 39, 39, 0.15)",
  },
}));

export default CustomTabSmallButton;
